import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box
} from '@mui/material';
import { SiteVisitCard, SiteVisitContainer } from '../../../components/site-visit-details/styled-components'
import { SiteVisitTitleContainer } from '../styled-components';
import { CustomizedText } from '../../../components/styled-componnets';

interface LostReasonItem {
    lost_reason_category: string;
    level_1: string;
    level_2: string | null;
    level_3: string | null;
    other_reason?: string;
}

interface LostTableProps {
    data: LostReasonItem[];
}

const renderTitle = () => (
    <CustomizedText fontSize={28} gutterBottom font={"Lato-Regular"}>
       Lost Reasons
    </CustomizedText>
);

const LostTable: React.FC<LostTableProps> = ({ data }) => {
    if (!data || data.length === 0) {
        return (
            <Box mt={2}>
                <Typography variant="body2" color="textSecondary" align="center">
                    No lost reasons selected.
                </Typography>
            </Box>
        );
    }

    return (
        <SiteVisitContainer>
            <SiteVisitTitleContainer sx={{ pl: 0, pr: 0 }}>
                {renderTitle()}
            </SiteVisitTitleContainer>
            <SiteVisitCard>
                <TableContainer sx={{ maxHeight: 400, mt: 2 }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}><CustomizedText fontSize={19}>S.No</CustomizedText></TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}><CustomizedText fontSize={19}>Category</CustomizedText></TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}><CustomizedText fontSize={19}>Level 1</CustomizedText></TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}><CustomizedText fontSize={19}>Level 2</CustomizedText></TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}><CustomizedText fontSize={19}>Level 3</CustomizedText></TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: 'bold' }}><CustomizedText fontSize={19}>Other Reason</CustomizedText></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>
                                        <CustomizedText fontSize={18}>{index + 1}</CustomizedText>
                                    </TableCell>
                                    <TableCell><CustomizedText fontSize={18}>{item.lost_reason_category}</CustomizedText></TableCell>
                                    <TableCell><CustomizedText fontSize={18}>{item.level_1}</CustomizedText></TableCell>
                                    <TableCell><CustomizedText fontSize={18}>{item.level_2 || '-'}</CustomizedText></TableCell>
                                    <TableCell><CustomizedText fontSize={18}>{item.level_3 || '-'}</CustomizedText></TableCell>
                                    <TableCell><CustomizedText fontSize={18}>{item.other_reason?.trim() || '-'}</CustomizedText></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </SiteVisitCard>
        </SiteVisitContainer>
    );
};

export default LostTable;
